export default __webpack_public_path__ + "static/media/chevron_rightCalendarIcon.f3fa124a.svg";